import { render, staticRenderFns } from "./HistoricoListaSujaTrabalhoEscravo.vue?vue&type=template&id=1402e95a&lang=pug"
import script from "./HistoricoListaSujaTrabalhoEscravo.vue?vue&type=script&lang=js"
export * from "./HistoricoListaSujaTrabalhoEscravo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports